class FormsButtonType {
  Enter() {
    return 0;
  }
  Search() {
    return 1;
  }
  Accept() {
    return 2;
  }
  Reject() {
    return 3;
  }
  Inquire() {
    return 4;
  }
  Show() {
    return 5;
  }
  AddNote() {
    return 6;
  }
  RejectActivation() {
    return 7;
  }
  SendSms() {
    return 8;
  }
  Send() {
    return 9;
  }
}
export default new FormsButtonType();
